export function hamburger() {
  const trigger = document.querySelector('.js-hamburger');
  const target = document.querySelector('.l-headerMenu');
  const links = target.querySelectorAll('a');

  trigger.addEventListener('click', () => {
    trigger.classList.toggle('is-active');
    target.classList.toggle('is-open');
  })

  links.forEach(element => {
    element.addEventListener('click', () => {
      trigger.classList.remove('is-active');
      target.classList.remove('is-open');
    })
  });
}